import * as tslib_1 from "tslib";
import { Exclude } from 'class-transformer';
export class ConveyanceClosingFeeRuleResultDto {
    constructor() {
        // Transient variable
        this.isSelected = false;
    }
}
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", Object)
], ConveyanceClosingFeeRuleResultDto.prototype, "isSelected", void 0);
